import styled, { keyframes } from "styled-components";
import { BASIC_DARK_GRAY, BASIC_ORANGE } from "../../../constants/colors";

// Keyframe for fadein animation
export const fadein = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9, 0.9);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1, 1);
  }
`;

export const PopupModalContainer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: all 0.5s ease;
`;

export const ModalContainer = styled.div<{ $isOpen: boolean }>`
  max-width: 640px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 85%;
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen
      ? "translate(-50%, -50%) scale(1, 1)"
      : "translate(-50%, -50%) scale(0.9, 0.9)"};
  padding: 40px 15px;
  animation: ${fadein} 0.5s forwards;
`;

export const ModalTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0;
  margin: 0 0 15px 0;
`;

export const ModalTitle = styled.p`
  white-space: pre-line;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
`;

export const ModalSubtitleContainer = styled.div`
  margin: 0 20px 15px 20px;
`;

export const ModalSubtitle = styled.div`
  padding: 0;
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.05em;
  color: ${BASIC_DARK_GRAY};
  text-align: center;
  white-space: pre-line;
`;

export const ModalWarning = styled(ModalSubtitle)`
  color: ${BASIC_ORANGE};
  font-weight: 600;
  text-align: center;
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  column-gap: 0.9375rem;
  row-gap: 0;
  width: 100%;
  align-items: center;

  button {
    flex: 1;
    max-width: 48%;
    margin: 0 10px;
    line-height: 1;
    font-weight: 600;
  }

  & > button:only-child {
    max-width: 300px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    button {
      max-width: 100%;
    }

    & > button:only-child {
      max-width: 100%;
    }
  }

  @media (min-width: 1024px) {
    & > button:only-child {
      max-width: 50%;
    }
  }
`;

export const ModalSubTitleWithBorder = styled.div`
  border: 1px solid ${BASIC_ORANGE};
  color: ${BASIC_ORANGE};
  padding: 5px;
  text-align: center;
`;
